export default __webpack_public_path__ + "static/media/alert-info.b627d64a.svg";